import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { DataService } from './services/DataService';
import Autosuggest from 'react-autosuggest';

const TravelSearch = () => {
    var [airports, setAirports] = useState([]);
    const history = useNavigate();
    const [tripType, setTripType] = useState('one-way');
    const [from, setFrom] = useState('');
    const [to, setTo] = useState('');
    const [departureDate, setDepartureDate] = useState(null);
    const [returnDate, setReturnDate] = useState(null);
    const [travellers, setTravellers] = useState(1);
    const [travelClass, setTravelClass] = useState('Economy');
    const [fromSuggestions, setFromSuggestions] = useState([]);
    const [toSuggestions, setToSuggestions] = useState([]);

    useEffect(() => {
        initData();
    }, [])

    const handleSearch = (e) => {
        e.preventDefault();
        // Implement the search functionality here
        console.log({ tripType, from, to, departureDate, returnDate, travellers, travelClass, });
        history("/search");
    };

    const initData = async () => {
        var data = await new DataService().getAirportsData();
        setAirports(data);
    }

    const getSuggestions = (value) => {
        const inputValue = value.trim().toLowerCase();
        const inputLength = inputValue.length;

        return inputLength === 0
            ? []
            : airports.filter(
                (airport) =>
                    airport.City.toLowerCase().includes(inputValue) ||
                    airport.AirportName.toLowerCase().includes(inputValue) ||
                    airport.IATA_FAA.toLowerCase().includes(inputValue)
            );
    };

    // Render each suggestion in the autocomplete dropdown
    const renderSuggestion = (suggestion) => (
        <div>
            {suggestion.IATA_FAA} - {suggestion.AirportName}, {suggestion.City}, {suggestion.Country}
        </div>
    );

    // Autocomplete handlers
    const handleFromChange = (e, { newValue }) => {
        setFrom(newValue);
    };

    const handleToChange = (e, { newValue }) => {
        setTo(newValue);
    };

    return (
        <>
            <section className="ftco-section ftco-no-pb ftco-no-pt">
                <div className="container1">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="ftco-search d-flex justify-content-center">
                                <div className="row">
                                    <div className="col-md-12 nav-link-wrap">
                                        <div className="nav nav-pills text-center" id="v-pills-tab" role="tablist" aria-orientation="vertical">

                                            <a className="nav-link active mr-md-1" onClick={() => setTripType('one-way')} id="v-pills-1-tab" data-toggle="pill" role="tab" aria-controls="v-pills-1" aria-selected="true">
                                                <input
                                                    type="radio"
                                                    className="btn-check"
                                                    name="tripType"
                                                    id="oneWay"
                                                    style={{ display: 'none' }}
                                                    autoComplete="off"
                                                    checked={tripType === 'one-way'}
                                                    onChange={() => setTripType('one-way')}

                                                />
                                                One
                                                Way</a>

                                            <a className="nav-link" id="v-pills-2-tab" onClick={() => setTripType('round-trip')} data-toggle="pill" href="#v-pills-2" role="tab" aria-controls="v-pills-2" aria-selected="false">
                                                <input
                                                    type="radio"
                                                    className="btn-check"
                                                    name="tripType"
                                                    id="roundTrip"
                                                    autoComplete="off"
                                                    style={{ display: 'none' }}
                                                    checked={tripType === 'round-trip'}
                                                    onChange={() => setTripType('round-trip')}
                                                />
                                                Round Trip</a>

                                        </div>
                                    </div>
                                    <div className="col-md-12 tab-wrap">

                                        <div className="tab-content" id="v-pills-tabContent">

                                            <div className="tab-pane fade show active" id="v-pills-1" role="tabpanel" aria-labelledby="v-pills-nextgen-tab">
                                                <form action="#" className="search-property-1">
                                                    <div className="row no-gutters">
                                                        <div className="col-md d-flex">
                                                            <div className="form-group p-4 border-0">
                                                                <label htmlFor="#">Source</label>
                                                                <div className="form-field">
                                                                    <div className="icon"><span className="fa fa-search"></span></div>
                                                                    {/* <input type="text" className="form-control" placeholder="Search place" /> */}
                                                                    <Autosuggest
                                                                        className="form-control"
                                                                        suggestions={fromSuggestions}
                                                                        onSuggestionsFetchRequested={({ value }) =>
                                                                            setFromSuggestions(getSuggestions(value))
                                                                        }
                                                                        onSuggestionsClearRequested={() => setFromSuggestions([])}
                                                                        getSuggestionValue={(suggestion) => `${suggestion.IATA_FAA} - ${suggestion.AirportName}, ${suggestion.City}, ${suggestion.Country}`}
                                                                        renderSuggestion={renderSuggestion}
                                                                        inputProps={{
                                                                            placeholder: 'From',
                                                                            value: from,
                                                                            onChange: handleFromChange,
                                                                            required: true,
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md d-flex">
                                                            <div className="form-group p-4">
                                                                <label htmlFor="#">Destination</label>
                                                                <div className="form-field">
                                                                    <div className="icon"><span className="fa fa-search"></span></div>
                                                                    {/* <input type="text" className="form-control" placeholder="Search place" /> */}
                                                                    <Autosuggest
                                                                        suggestions={toSuggestions}
                                                                        onSuggestionsFetchRequested={({ value }) =>
                                                                            setToSuggestions(getSuggestions(value))
                                                                        }
                                                                        onSuggestionsClearRequested={() => setToSuggestions([])}
                                                                        getSuggestionValue={(suggestion) => `${suggestion.IATA_FAA} - ${suggestion.AirportName}, ${suggestion.City}, ${suggestion.Country}`}
                                                                        renderSuggestion={renderSuggestion}
                                                                        inputProps={{
                                                                            placeholder: 'To',
                                                                            value: to,
                                                                            onChange: handleToChange,
                                                                            required: true,
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>



                                                    </div>
                                                    <div className='row no-gutters' style={{ borderTop: '1px solid #efefef' }}>
                                                        <div className="col-md d-flex">
                                                            <div className="form-group p-4  border-0">
                                                                <label htmlFor="#">Departure date</label>
                                                                <div className="form-field">
                                                                    <div className="icon"><span className="fa fa-calendar"></span></div>
                                                                    <DatePicker
                                                                        selected={departureDate}
                                                                        onChange={(date) => setDepartureDate(date)}
                                                                        dateFormat="dd MMM yyyy"
                                                                        required
                                                                        placeholderText="Departure Date"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md d-flex">
                                                            <div className="form-group p-4">
                                                                <label htmlFor="#">Return date</label>
                                                                <div className="form-field">
                                                                    <div className="icon"><span className="fa fa-calendar"></span></div>
                                                                    <div className='returndate'>
                                                                        {tripType === 'round-trip' && (<DatePicker
                                                                            selected={returnDate}
                                                                            onChange={(date) => setReturnDate(date)}
                                                                            dateFormat="dd MMM yyyy"
                                                                            required
                                                                            placeholderText="Return Date"

                                                                        />)}
                                                                        {tripType !== 'round-trip' && (
                                                                            <div className='form-control'>Return Date</div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md d-flex">
                                                            <div className="form-group p-4">
                                                                <label htmlFor="#">Travellers</label>
                                                                <div className="form-field">
                                                                    <div className="select-wrap">
                                                                        <div className="icon"><span className="fa fa-chevron-down"></span></div>
                                                                        <select className="form-control" value={travellers} onChange={(e) => setTravellers(Number(e.target.value))}>
                                                                            <option value="1">1 Traveller</option>
                                                                            <option value="2">2 Adults (12Yrs and above)</option>
                                                                            <option value="3">3 Children (2-11 yrs)</option>
                                                                            <option value="4">4 Infants (below 2 yrs)</option>
                                                                        </select>


                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md d-flex">
                                                            <div className="form-group p-4">
                                                                <label htmlFor="#">Class</label>
                                                                <div className="form-field">
                                                                    <div className="select-wrap">
                                                                        <div className="icon"><span className="fa fa-chevron-down"></span></div>
                                                                        <select className="form-control" value={travelClass} onChange={(e) => setTravelClass(e.target.value)}>
                                                                            <option value="Economy">Class</option>
                                                                            <option value="Economy">Economy</option>
                                                                            <option value="PremiumEconomy">Premium Economy</option>
                                                                            <option value="Business">Business</option>
                                                                            <option value="FirstClass">First Class</option>
                                                                        </select>


                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='row no-gutters' style={{ borderTop: '1px solid #efefef' }}>


                                                        <div className="col-md ">
                                                            <div className="form-group border-0">
                                                                <div className="form-field float-end">
                                                                    <input type="submit" onClick={handleSearch} value="Search" className="align-self-stretch btn btn-primary search_button" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


        </>
    );
};

export default TravelSearch;